import React, { useState } from "react";
import { getComplianceByName, saveCompliance } from "../../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../../validation/ToastContainer";
import { hasErrors } from "../../../../utils";
import { connect } from "react-redux";
import ComplianceNameField from "./ComplianceNameField";
import TargetTypeWizardModal from "../TargetTypeWizardModal";

function CreateComplianceModal({ setShowModal, validationErrors, onBack }) {

    const [compliance, setCompliance] = useState({});

    const onSaveClick = async () => {

        const serverCompliance = await getComplianceByName(compliance.name);
        let savedCompliance;

        if (serverCompliance.error && serverCompliance.statusCode === 404) {
            savedCompliance = await saveCompliance(compliance);
        } else {
            showDangerToast(`Compliance with name '${compliance.name}' already exist`, "Save Compliance")
        }

        if (savedCompliance) {
            showSuccessToast("Compliance created", "Save Compliance");
            setShowModal(false);
        }

    }

    return (
        <TargetTypeWizardModal
            title="Add Compliance Wizard"
            subtitle="Create a compliance target type."
            onClose={() => setShowModal(false)}
            onBack={onBack}
            onSubmit={onSaveClick}
            submitLabel="Save"
            submitDisabled={hasErrors(validationErrors)}
            contentClassName="target-type-wizard-form__content--compact"
        >
            <ComplianceNameField compliance={compliance} setCompliance={setCompliance} />
        </TargetTypeWizardModal>
    );

}

function mapStateToProps(state) {
    return {
        validationErrors: state.validation
    }
}

export default connect(mapStateToProps)(CreateComplianceModal);
